import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'catalogos/tipo-de-movimiento-de-personal';

/**
 * GET Tipos de Movimiento de Personal
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeMovimientoDePersonal = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo de Movimiento de Personal
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoDeMovimientoDePersonal = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo de Movimiento de Personal
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeMovimientoDePersonal = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Movimiento de Personal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeMovimientoDePersonal = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Movimiento de Personal
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTipoDeMovimientoDePersonal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Tipo de Movimiento de Personal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarTipoDeMovimientoDePersonal = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
